"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./index'));



//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/ng2-charts/ng2-charts.js
// module id = ../../../../ng2-charts/ng2-charts.js
// module chunks = 8